import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { isStatuspage } from '@atlassian/cssxp-utils-product';
import { isTrialEntitlement, getTotalDaysInTrial, getTotalDaysinTrialForStatusPage } from '../../../utils';

export const getCurrentTotalTrialLength = (entitlement: EntitlementDetails) => {
  const isTrial = isTrialEntitlement(entitlement, isStatuspage(entitlement?.productId));
  const upgradeTrialOfferingId: string | null = entitlement.upgradeTrial?.offeringId ?? null;
  if (isTrial) {
    if (isStatuspage(entitlement?.productId)) {
      return getTotalDaysinTrialForStatusPage(entitlement);
    } else {
      return getTotalDaysInTrial(entitlement?.subscription, entitlement.offeringId as string, upgradeTrialOfferingId);
    }
  }
  return null;
};
